import { createApp } from 'vue';
import App from './App.vue';

// const vconsole = new VConsole();
const app = createApp( App );

app.directive( "sendGAsignal", {
    mounted ( el, binding ) {
        let { event_type, event_category, event_label } = binding.value || {};
        el.onclick = () => {
            gtag( 'event', event_type, { event_category, event_label } );
            // console.log( event_type, event_category, event_label );
        };
    },
    updated ( el, binding ) {
        let { event_type, event_category, event_label } = binding.value || {};
        el.onclick = () => {
            gtag( 'event', event_type, { event_category, event_label } );
            // console.log( event_type, event_category, event_label );
        };
    },
} );

app.mount( '#app' );

